import React, { Component } from "react";
import "./style.css";
class MajorQueryDesc extends Component {
  render() {
    const { visible } = this.props;
    return (
      <div
        className={
          visible === true
            ? "majorQueryDesc_box"
            : "majorQueryDesc_box display_none"
        }
      >
        <img
          alt=""
          src={require("../../../../../../images/powerful/majorquery/major_query_tip.png")}
        ></img>
      </div>
    );
  }
}

export default MajorQueryDesc;



// WEBPACK FOOTER //
// ./src/containers/PowerfulQuery/components/MajorQuery/components/MajorQueryDesc/index.js